import { render, staticRenderFns } from "./tradesmanList.vue?vue&type=template&id=75667ae2&scoped=true&"
import script from "./tradesmanList.vue?vue&type=script&lang=js&"
export * from "./tradesmanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75667ae2",
  null
  
)

export default component.exports